<template>
  <div class="custom-modal custom-modal_delete-keywords" data-cy="modal-delete-keywords">
    <div class="custom-modal__header">
      {{ $t('delete-keyword-question') }}
    </div>
    <div class="custom-modal__body">
      {{ $t('delete-keyword-note') }}
    </div>
    <div class="custom-modal__footer">
      <kw-button :button-text="$t('cancel')" button-type="text" data-cy="cancel-delete-modal" @click="close" />
      <kw-button
        :button-text="$t('delete')"
        button-type="primary"
        :loading="loading"
        data-cy="delete-button-in-delete-modal"
        @click="confirmDelete"
      />
    </div>

    <global-events @keyup.enter="confirmDelete" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DashboardMixin from '@/mixins/DashboardMixin';
export default {
  name: 'ConfirmDeletingKeywords',
  mixins: [DashboardMixin],
  props: {
    keywords: {
      type: Array,
      required: true,
    },
    isAllSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['getIsAllCheckboxesSelected']),
  },
  methods: {
    ...mapActions(['deleteKeywords', 'undoDeleting', 'resetAllKeywords']),
    async confirmDelete() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        const param = this.isAllSelected ? null : this.keywords;
        await this.deleteKeywords(param);
        if (!this.getIsAllCheckboxesSelected) {
          this.$toastr.createToastr({
            msg: this.$t('keywords-delete-msg'),
            type: 'success',
            undoCallback: this.handlerUndoDeleting,
          });
        } else {
          this.$toastr.createToastr({
            msg: this.$t('keywords-delete-msg'),
            type: 'success',
          });
        }
        this.resetAllKeywords();
      } catch (e) {
        this.$toastr.e(e);
      }

      this.loading = false;
      this.close();
    },
    async handlerUndoDeleting() {
      try {
        await this.undoDeleting();
        this.$toastr.s(this.$t('keywords-restore-msg'));
      } catch (error) {
        return this.$toastr.e(error);
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '~sass/modal';

.custom-modal.custom-modal_delete-keywords {
  .custom-modal__header {
    padding-bottom: 8px;
  }

  .custom-modal__body {
    margin: 0;
    padding: 0 16px 9px;
    font-size: 12px;
    color: #24242c;
  }

  .custom-modal__footer {
    button {
      width: 102px;

      &:last-child {
        background-color: kw-color(kw-red, 1);
        border: none;
      }
    }
  }
}
</style>
